import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const FormTextArea = ({
    label,
    name,
    value,
    onChange,
    placeholder,
    required = false,
    error,
    className = '',
    disabled = false,
    rows = 4,
    ...props
}) => {
    const [isShaking, setIsShaking] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (error) {
            setHasError(true);
            setIsShaking(true);
            const timer = setTimeout(() => setIsShaking(false), 500);
            return () => clearTimeout(timer);
        } else {
            setHasError(false);
        }
    }, [error]);

    const handleChange = (e) => {
        onChange(e);
        if (hasError) {
            setHasError(false);
        }
    };

    return (
        <div className={`mb-4 ${className}`}>
            <label className="block text-sm font-medium text-gray-700 mb-2">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <motion.textarea
                name={name}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                rows={rows}
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors resize-vertical ${hasError || error
                    ? 'border-red-500 bg-red-50'
                    : 'border-gray-300'
                    } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                animate={isShaking ? { x: [-10, 10, -10, 10, 0] } : {}}
                transition={{ duration: 0.5 }}
                {...props}
            />
            {error && (
                <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-red-600 text-sm mt-1"
                >
                    {error}
                </motion.p>
            )}
        </div>
    );
};

export default FormTextArea;


